import React from 'react';
import styles from './Contacts.module.scss'
import Ico3 from "./Ico3";


const Contacts = (props) => {
    return (
        <React.Fragment>
                <div><h2>Контакты</h2></div>
            <div className={styles.contacts_items}>
                <div className={styles.contacts_item_left}>
                    <span>E-mail :</span>
                    <span>Skype :</span>
                    <span>Viber :</span>
                    <span>WhatsApp :</span>
                    <span>Telegram :</span>
                </div>
                <div className={styles.contacts_items_right}>
                    <span>conter10@mail.ru</span>
                    <span>pioner923</span>
                    <span>+48576116436</span>
                    <span>+34698779553</span>
                    <span>+34688779553</span>
                </div>
                <div className={styles.contacts_image}>
                    <Ico3/>
                </div>
            </div>

        </React.Fragment>
    );
};

export default Contacts;